const fileStateIcon = (state) => {
  const stateIcon = {
    'application/pdf': 'mdi-file-document',
    'image/jpg': 'mdi-image',
    'image/png': 'mdi-image',
    'audio/mpeg': 'mdi-music',
    'application/mp3': 'mdi-music',
    'application/shp': 'mdi-map',
    'application/kml': 'mdi-map',
  };
  return stateIcon[state];
};

export default fileStateIcon;



// WEBPACK FOOTER //
// ./src/mixins/file-state-icon.js